module.exports = __webpack_public_path__ + "img/dog-min.476308b5.jpg";